<div class="lp-root" dir="rtl">

  <!-- Loading -->
  @if (loading) {
    <div class="lp-state">
      <div class="lp-spinner"></div>
      <span class="lp-state-lbl">טוען...</span>
    </div>
  }

  <!-- Error -->
  @if (error && !loading) {
    <div class="lp-state">
      <div class="lp-state-icon"><i class="fa fa-exclamation-triangle"></i></div>
      <p class="lp-state-lbl">לא ניתן לטעון את מדיניות הפרטיות</p>
      <button class="lp-retry" (click)="ngOnInit()">
        <i class="fa fa-refresh"></i> נסה שוב
      </button>
    </div>
  }

  <!-- Content -->
  @if (doc && !loading) {
    <!-- Hero -->
    <div class="lp-hero" dir="rtl">
      <div class="lp-hero-inner">
        <div class="lp-hero-icon"><i class="fa fa-shield"></i></div>
        <div class="lp-hero-txt">
          <h1 class="lp-hero-title">{{ doc.title }}</h1>
          <div class="lp-hero-chips">
            @if (doc.version) {
              <span class="lp-chip">
                <i class="fa fa-tag"></i>&nbsp;גרסה {{ doc.version }}
              </span>
            }
            @if (doc.effective_date) {
              <span class="lp-chip">
                <i class="fa fa-calendar-o"></i>&nbsp;תוקף מ-{{ doc.effective_date }}
              </span>
            }
          </div>
        </div>
      </div>
    </div>
    <!-- Body -->
    <div class="lp-body" dir="rtl">
      <div class="lp-card" dir="rtl">
        <div class="lp-content" dir="rtl" [innerHTML]="safeContent"></div>
      </div>
      <!-- Footer -->
      <div class="lp-footer" dir="rtl">
        <span>עודכן לאחרונה: {{ doc.updated_at | date:'dd/MM/yyyy' }}</span>
      </div>
    </div>
  }
</div>
